import React from "react";
import { useTranslation } from "react-i18next";
import { LuChevronLeft, LuChevronRight, LuCalendarDays, LuCalendarRange } from "react-icons/lu";
import { OverviewButton } from "../overview/overviewStyles";
import { Toolbar, CalendarNavigation, ArrowGroup, ArrowButton, ViewButtons, ViewButton } from "./scheduleStyles";

export default function CalendarCustomToolbar({ label, onNavigate, onView, view }) {
  const { t } = useTranslation();
  return <Toolbar>
    <CalendarNavigation>
      <ArrowGroup>
        <ArrowButton type="button" aria-label={t("ui.components.restaurantSchedule.calendarCustomToolbar.anterior")} onClick={() => onNavigate("PREV")}><LuChevronLeft /></ArrowButton>
        <ArrowButton type="button" aria-label={t("ui.components.restaurantSchedule.calendarCustomToolbar.proximo")} onClick={() => onNavigate("NEXT")}><LuChevronRight /></ArrowButton>
      </ArrowGroup>
      <h2 aria-live="polite">{label}</h2>
      <OverviewButton type="button" onClick={() => onNavigate("TODAY")}>{t("ui.components.restaurantSchedule.restaurantCalendarOpenClosedDays.today")}</OverviewButton>
    </CalendarNavigation>
    <ViewButtons>
      <ViewButton type="button" $active={view === "month"} aria-pressed={view === "month"} onClick={() => onView("month")}><LuCalendarDays />{t("ui.components.restaurantSchedule.calendarCustomToolbar.mes")}</ViewButton>
      <ViewButton type="button" $active={view === "week"} aria-pressed={view === "week"} onClick={() => onView("week")}><LuCalendarRange />{t("ui.components.restaurantSchedule.calendarCustomToolbar.semana")}</ViewButton>
    </ViewButtons>
  </Toolbar>;
}
